import React from "react";

const CaretRight = () => {
  return <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.7137 14.4637L10.9637 23.2137C10.8393 23.3297 10.6748 23.3928 10.5048 23.3898C10.3348 23.3868 10.1726 23.3179 10.0523 23.1977C9.93208 23.0774 9.86321 22.9152 9.86021 22.7452C9.85721 22.5752 9.92032 22.4106 10.0362 22.2862L18.3214 14L10.0362 5.71374C9.92032 5.58933 9.85721 5.42479 9.86021 5.25478C9.86321 5.08477 9.93208 4.92255 10.0523 4.80232C10.1726 4.68208 10.3348 4.61321 10.5048 4.61021C10.6748 4.60721 10.8393 4.67032 10.9637 4.78624L19.7137 13.5362C19.8366 13.6593 19.9057 13.8261 19.9057 14C19.9057 14.1739 19.8366 14.3407 19.7137 14.4637Z" fill="currentColor"/>
  </svg>
}

export default CaretRight;
